import styled from 'styled-components';
import { spacing } from '@pb/styles';
import { Section } from '@pb/shared/ui/atoms/section';
import { TMainContainerProperties } from './layout.types';

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

export const StyledMain = styled(Section)<TMainContainerProperties>`
    flex-grow: 1;
    padding-top: ${({ hasSteps }) =>
        hasSteps ? `${spacing(2)}` : `${spacing(6)}`};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        padding: ${spacing(8, 0)};
    }
`;

export const StyledContent = styled.div`
    flex: 1;
    max-width: 75rem;
    margin: auto;
    width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.s.min}) {
        max-width: 47.2rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        max-width: 62rem;
    }
`;

export const StyledContainer = styled.div`
    && {
        margin: 2rem 0;
        padding: 0;
    }
`;
